<template>
  <header class="fixed top-0 left-0 right-0 z-50 bg-white border-b border-gray-200">
    <nav class="container mx-auto px-4">
      <div class="flex items-center justify-between h-20">
        <!-- Logo -->
        <div class="flex items-center">
          <router-link to="/" class="flex items-center space-x-3">
            <img src="/images/logo.svg" alt="Hong Kai Logo" class="h-12 w-auto">
            <div class="hidden sm:block">
              <!-- <h1 class="text-xl font-light text-gray-900">
                閎凱綠能遮陽工程
              </h1> -->
            </div>
          </router-link>
        </div>

        <!-- Language Switcher -->
        <div class="relative">
          <button
            @click="toggleDropdown"
            class="flex items-center space-x-1 text-gray-600 hover:text-gray-900 transition-colors"
          >
            <span class="text-sm font-medium">{{ getCurrentLanguage().name }}</span>
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
            </svg>
          </button>

          <!-- Dropdown Menu -->
          <div
            v-if="showDropdown"
            class="absolute right-0 mt-2 w-32 bg-white border border-gray-200 rounded-md shadow-lg z-50"
          >
            <div class="py-1">
              <button
                v-for="lang in availableLanguages"
                :key="lang.code"
                @click="selectLanguage(lang.code)"
                :class="[
                  'w-full text-left px-4 py-2 text-sm hover:bg-gray-100 transition-colors',
                  currentLanguage === lang.code ? 'bg-blue-50 text-blue-700' : 'text-gray-700'
                ]"
              >
                {{ lang.name }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </nav>
  </header>
</template>

<script>
import { ref } from 'vue'
import { useLanguageStore } from '@/stores/language'

export default {
  name: 'AppHeader',
  setup() {
    const languageStore = useLanguageStore()
    const showDropdown = ref(false)

    const currentLanguage = languageStore.currentLanguage
    const availableLanguages = languageStore.availableLanguages
    const setLanguage = languageStore.setLanguage
    const getCurrentLanguage = languageStore.getCurrentLanguage

    const toggleDropdown = () => {
      showDropdown.value = !showDropdown.value
    }

    const selectLanguage = (langCode) => {
      setLanguage(langCode)
      showDropdown.value = false
    }

    // Close dropdown when clicking outside
    const handleClickOutside = (event) => {
      const dropdown = event.target.closest('.relative')
      if (!dropdown) {
        showDropdown.value = false
      }
    }

    // Add event listener
    if (typeof window !== 'undefined') {
      window.addEventListener('click', handleClickOutside)
    }

    return {
      currentLanguage,
      availableLanguages,
      setLanguage,
      getCurrentLanguage,
      showDropdown,
      toggleDropdown,
      selectLanguage
    }
  }
}
</script>

<style scoped>
/* Header specific styles */
.backdrop-blur-sm {
  backdrop-filter: blur(4px);
}

/* Smooth transitions */
.header-transition {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
</style>